import React from "react";
import { Metadata } from "../../../Utilities/Metadata";
import { AppCard } from "./AppCard";
import availableApps from "./AvailableApps.json";
import { Link, useLocation } from "react-router-dom";
import { TbArrowBackUp } from "react-icons/tb";

const AppCategory = ({ title, category }) => {
  let categoryApps = availableApps.filter((app) => {
    return app.category === category;
  });

  const location = useLocation();

  let metadata = {
    title: `The Blocks: ${title}`,
    image: "",
    description: "",
    url: `https://theblocks.finance${location.pathname}`,
  };

  return (
    <div id="blocks-calculators">
      {Metadata(metadata)}
      <Link to="/apps" className="back-to-apps">
        <TbArrowBackUp /> all resources
      </Link>
      <h1 className="page-title">{title}</h1>
      {categoryApps.map((app, index) => {
        return (
          <AppCard
            key={index}
            appIcon={app.appIcon}
            title={app.title}
            badge={app.badge}
            description={app.description}
            actions={app.actions}
          />
        );
      })}
    </div>
  );
};

export default AppCategory;
